import { useState } from "react";
import { TimePicker } from "antd";
import DateTimePicker from "react-datetime-picker";
import dayjs from "dayjs";
import { offsetDateByMinutes } from "utils";
import useUniversalStore from "store/universalStore";
import { reminderAPI } from "services";
import { toast } from "sonner";

const AddReminder = () => {
    const { accountId } = useUniversalStore((state) => state);
    const [reminder, setReminder] = useState(null);
    const [sheduleReminder, setSheduleReminder] = useState(offsetDateByMinutes(5));
    const [edit, setEdit] = useState(false);

    const currentDateTime = dayjs(sheduleReminder);
    const today = dayjs(); // Get the current date and time

    const handleClose = () => setReminder(null);
    
    const handleChangeDate = (e) => {
        const newDate = new Date(e);
        const currentDate = new Date();
        if (newDate < currentDate) return;
        setSheduleReminder(newDate); // only return future dates
    };

    //method to shedule reminder
    const handleSchedule = async (e) => {
        e.preventDefault();
        try {
            const reminder = await reminderAPI.addReminder( accountId, sheduleReminder, true );
            if (reminder) {
                setReminder(reminder);
                toast.success("Reminder scheduled successfully!");
            }
        } catch (error) {
            console.log("error",error);
            toast.error("Failed to schedule Reminder!");
        }
    };

    // Handle time change
    const handleTimeChange = (e) => setSheduleReminder(new Date(e));

    // Add this function to check if selected time is valid
    const isTimeValid = () => {
        const selectedTime = dayjs(sheduleReminder);
        return selectedTime.isAfter(dayjs());
    };

    return (
        <div className="animate__animated animate__fadeIn">
            <div className="mb-1">
                <label className="display-6 py-2 text-black">
                    When do you want to be Reminded?
                </label>
                <div className="d-flex py-3 w-100 justify-content-end">
                    <DateTimePicker
                        className="w-100"
                        calendarIcon={null}
                        clearIcon={null}
                        minDate={offsetDateByMinutes(5)}
                        disableClock={true}
                        format="dd-MM-y"
                        onChange={handleChangeDate}
                        value={sheduleReminder}
                    />
                    <TimePicker
                        format="hh:mm A"
                        value={dayjs(sheduleReminder)}
                        onChange={handleTimeChange}
                        changeOnScroll={false}
                        needConfirm={true}
                        allowClear={false}
                        use12Hours={true}
                        showNow={false}
                        suffixIcon={null}
                        disabledTime={() => {
                            const selectedDate = dayjs(sheduleReminder);
                            const isToday = selectedDate.isSame(today, 'day');
                            return {
                                disabledHours: () => isToday ? Array.from({length: currentDateTime.hour()}, (_, i) => i) : [],
                                disabledMinutes: (hour) => isToday && hour === currentDateTime.hour() ? 
                                    Array.from({length: currentDateTime.minute()}, (_, i) => i) : []
                            };
                        }}
                    />
                </div>
            </div>
            <div className="row my-3">
                <div className="col-md-6 d-grid mt-md-0">
                    <button
                        type="cancel"
                        className="w-100 btn btn-outline-app"
                        data-bs-dismiss="offcanvas"
                        onClick={() => (edit ? setEdit(false) : handleClose())}
                    >
                        <b className="fs-5">Cancel</b>
                    </button>
                </div>
                <div className="col-md-6 d-grid mt-md-0">
                    <button
                        type="submit"
                        className="btn btn-app block py-3"
                        data-bs-dismiss="offcanvas"
                        disabled={!isTimeValid()}
                        onClick={handleSchedule}>
                        <b className="fs-5">Schedule</b>
                    </button>
                </div>
            </div>
            <br />
        </div>
    )
}

export default AddReminder;